import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Logo Icons
const MicrosoftIcon = ({
  className,
  size = 16,
  x,
  y,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-microsoft${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    x={x}
    y={y}
  >
    <title>Microsoft</title>
    <path
      d="M2 2H7.7023V7.7023H2V2Z"
      fill="var(--color-brand-microsoft-1)"
      id="icon-logo-1-fill"
    />
    <path
      d="M8.29773 2H14V7.7023H8.29773V2Z"
      fill="var(--color-brand-microsoft-2)"
      id="icon-logo-1-fill"
    />
    <path
      d="M2 8.29773H7.7023V14H2V8.29773Z"
      fill="var(--color-brand-microsoft-3)"
      id="icon-logo-1-fill"
    />
    <path
      d="M8.29773 8.29773H14V14H8.29773V8.29773Z"
      fill="var(--color-brand-microsoft-4)"
      id="icon-logo-1-fill"
    />
  </OpticksSvgElement>
);

export default MicrosoftIcon;
